import Axios from "axios";
import {
    SET_ASSET_ACQUISITION_LIST,
    UNSET_ASSET_ACQUISITION_LIST,
    SET_EDITING_ASSET_ACQUISITION,
    UNSET_EDITING_ASSET_ACQUISITION,
    SET_VIEW_ASSET_ACQUISITION,
    UNSET_VIEW_ASSET_ACQUISITION
} from "@/store/mutation-types";

import { saveUpdateAssetAcquisition, getAssetAcquisitionList, getAssetAcquisitionById } from "@/store/api";

const state = {
    getAssetAcquisitionList: [],
    getEditingAssetAcquisition: null,
    getViewingAssetAcquisition: null,
};

const getters = {
    getAssetAcquisitionList(state) {
        return state.getAssetAcquisitionList;
    },
    getEditingAssetAcquisition(state) {
        return state.getEditingAssetAcquisition;
    },
    getViewingAssetAcquisition(state) {
        return state.getViewingAssetAcquisition;
    }
};

const mutations = {
    [SET_ASSET_ACQUISITION_LIST](state, data) {
        state.getAssetAcquisitionList = data;
    },
    [UNSET_ASSET_ACQUISITION_LIST](state) {
        state.getAssetAcquisitionList = [];
    },
    [SET_EDITING_ASSET_ACQUISITION](state, data) {
        state.getEditingAssetAcquisition = data;
    },
    [UNSET_EDITING_ASSET_ACQUISITION](state) {
        state.getEditingAssetAcquisition = null;
    },
    [SET_VIEW_ASSET_ACQUISITION](state, data) {
        state.getViewingAssetAcquisition = data;
    },
    [UNSET_VIEW_ASSET_ACQUISITION](state) {
        state.getViewingAssetAcquisition = null;
    }
};

const actions = {
    saveUpdateAssetAcquisition({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateAssetAcquisition, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getAssetAcquisitionList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetAcquisitionList, { params: data})
                .then(function (response) {
                    commit('SET_ASSET_ACQUISITION_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_ACQUISITION_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getAssetAcquisitionById({ commit }, data) {
        const getAssetAcquisitionRecordById = `${getAssetAcquisitionById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getAssetAcquisitionRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};

